enum SiteTypeOption {
  All = 'All',
  Retail = 'Retail',
  Showroom = 'Showroom',
  Distribution = 'Distribution Center',
  Corporate = 'HQ / Remote Office',
  DataCenter = 'Data Center',
  Lab = 'Lab',
}

export default SiteTypeOption;
